import { render, staticRenderFns } from "./ChiTietDonVi.vue?vue&type=template&id=43aa10f5&"
import script from "./ChiTietDonVi.vue?vue&type=script&lang=js&"
export * from "./ChiTietDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports